import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './Checkbox.module.scss';
import classnames from 'classnames';
import Checkbox, { CheckboxProps } from '../CheckBox/Checkbox';
import { Placement } from 'react-bootstrap/esm/Overlay';

interface OwnProps extends CheckboxProps {
  tooltip?: string;
  position?: Placement;
  isDarkTooltip?: boolean;
}

const CheckboxTooltip = ({
  tooltip,
  position,
  isDarkTooltip,
  ...rest
}: OwnProps) => {
  return tooltip ? (
    <OverlayTrigger
      placement={position || 'bottom-start'}
      overlay={
        <Popover
          id="checkbox_popover"
          className={classnames(styles.popover, {
            [styles.darkTooltip]: isDarkTooltip,
          })}
        >
          <Popover.Content
            className={classnames({
              [styles.popoverBody]: isDarkTooltip,
            })}
          >
            {tooltip}
          </Popover.Content>
        </Popover>
      }
    >
      <div className="d-inline-block">
        <Checkbox {...rest} />
      </div>
    </OverlayTrigger>
  ) : (
    <Checkbox {...rest} />
  );
};
export default CheckboxTooltip;
